import { Injectable } from '@angular/core'
import { EntitySignalStore } from '@awork/core/state/signal-store/entitySignalStore'
import { TimeBooking } from '@awork/features/planner/models/time-booking.model'
import type { Project } from '@awork/features/project/models/project.model'

@Injectable({ providedIn: 'root' })
export class TimeBookingStore extends EntitySignalStore<TimeBooking> {
  constructor() {
    super({
      name: 'timeBooking',
      entityConstructor: timeBooking => new TimeBooking(timeBooking),
      nullableProps: ['projectId', 'project']
    })
  }

  /**
   * Updates all the time bookings of the project in the store
   * @param {Project} updatedProject the updated project
   */
  updateProjectsTimeBookings(updatedProject: Project): void {
    if (updatedProject) {
      this.update(
        timeBooking => timeBooking.project?.id === updatedProject.id,
        () => {
          return {
            project: updatedProject
          }
        }
      )
    }
  }
}
